import React from 'react';
import Button from 'eymp-uicomps/components/Button';
import PropTypes from 'prop-types';
import './ButtonComponent.scss';

export class ButtonComponent extends React.Component {
  render() {
    const { text, imgLeft, imgRight, ...otherProps } = this.props;
    return (
      <span className="new-button">
        <Button {...otherProps}>
          <img src={imgLeft} /> {text} <img src={imgRight} />
        </Button>
      </span>
    );
  }
}

ButtonComponent.propTypes = {
  text: PropTypes.string.isRequired,
};

export default ButtonComponent;
